import _ from 'lodash';
import { AllCountries, Country } from './Country';
import { AcceptedCountries } from './constants';
export function strEnum(o) {
    return o.reduce((res, key) => {
        res[key] = key;
        return res;
    }, Object.create(null));
}
export const isCustomStrategy = (value) => (typeof value === 'string' ? value === 'Custom' : value.info.Name === 'Custom');
export const isKnownStrategyType = (value) => isCustomStrategy(value) === false;
export const isKnownStrategy = (value) => isCustomStrategy(value) === false;
export function isStrategy(strategy, stratName) {
    if (_.isNil(stratName)) {
        return false;
    }
    if (typeof stratName === 'string') {
        return _.includes(strategy.map(s => _.toLower(s.info.Name)), _.toLower(stratName));
    }
    return false;
}
export const getGroupedCountryOptions = (clearer, isSecureAccountStep) => {
    const acceptedCountries = _.filter(AllCountries, c => _.includes(AcceptedCountries, c));
    const usaCountry = acceptedCountries.find(c => c === Country.UnitedStatesOfAmerica);
    const otherAcceptedCountries = acceptedCountries.filter(c => c !== Country.UnitedStatesOfAmerica);
    const sortedOtherAccepted = _.sortBy(otherAcceptedCountries, c => _.indexOf(AcceptedCountries, c));
    return _.concat(usaCountry ? [usaCountry] : [], sortedOtherAccepted, [null], // separator
    _.filter(AllCountries, c => !_.includes(AcceptedCountries, c)));
};
export function isResponseCodeDescription(value) {
    if (_.isNil(value)) {
        return false;
    }
    const name = _.get(value, 'name', undefined);
    const description = _.get(value, 'description', undefined);
    const descriptionisValid = typeof description === 'string' || typeof description === 'function';
    return typeof name === 'string' && descriptionisValid;
}
//# sourceMappingURL=util.js.map